import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextSF from '../../../widgets/form/InputTextSF'
import './EventEditModal.css'

const EventEditModalUI = ({ 
  context, 
  messageList, 
  successMsg, 
  errorList, 
  setErrorList,
  // modes
  editMode, 
  submitted,
  // form data
  status, 
  onStatusChange, 
  statusError, 
  setStatusError,
  adminApprovalRequired, 
  onAdminApprovalRequiredChange, 
  adminApprovalRequiredError, 
  setAdminApprovalRequiredError,
  reminderIteration, 
  onReminderIterationChange, 
  reminderIterationError, 
  setReminderIterationError,
  // event handlers
  onSubmit, 
  onCancelClick
}) => {
  const statusOptions = [
    { key: 'Active', value: 'Active' },
    { key: 'Inactive', value: 'Inactive' },
    // { key: 'Pending', value: 'Pending' }
  ]

  const approvalOptions = [
    { key: 'Yes', value: 'Yes' },
    { key: 'No', value: 'No' }
  ]

  const reminderIterationOptions = [
    { key: '1', value: '1' },
    { key: '2', value: '2' },
    { key: '3', value: '3' },
    { key: '4', value: '4' },
    { key: '5', value: '5' }
  ]

  return (
    <ModalFormUI
      context={context}
      messageList={messageList || []}
      titleLabel="Edit Event Name"
      buttonLabel="Update"
      cancelLabel="Cancel"
      isOpen={editMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
      <div className="event-edit-form">
        <InputSelectSF
          name="status"
          label="Status"
          messageList={messageList || []}
          value={status}
          onChange={onStatusChange}
          optionList={statusOptions}
          error={statusError}
          setError={setStatusError}
          required={true}
        />
        
        <InputSelectSF
          name="adminApprovalRequired"
          label="Admin Approval Required"
          messageList={messageList || []}
          value={adminApprovalRequired}
          onChange={onAdminApprovalRequiredChange}
          optionList={approvalOptions}
          error={adminApprovalRequiredError}
          setError={setAdminApprovalRequiredError}
          required={true}
        />
        
        <InputSelectSF
          name="reminderIteration"
          label="Reminder Iteration"
          messageList={messageList || []}
          value={reminderIteration}
          onChange={onReminderIterationChange}
          error={reminderIterationError}
          setError={setReminderIterationError}
          required={true}
          optionList={reminderIterationOptions}
        />
      </div>
    </ModalFormUI>
  )
}

export default EventEditModalUI
